<template>
    <div>
        <b-form-row  class="mt-4 mb-3">
            <div class="col-12 d-flex align-items-center">
                <div class="d-flex flex-column mr-3">
                    <strong class="mr-3">Добавить</strong>
                    <small class="text-secondary" v-if="remainingCount !== null && remainingCount > 0">Осталось {{ remainingCount }}</small>
                </div>
                <b-form-radio-group v-model="existing" :options="existingChoices" buttons button-variant="info" @change="fetchNextRegNumber"/>
            </div>
        </b-form-row>

        <div v-show="existing">
            <b-form-row class="mb-2">
                <div class="col-xs-12 col-lg-8">
                        <single-select name="selectedAnimal"
                                       class="flex-grow-1"
                                       v-model="selectedAnimal"
                                       :url="getAnimalsUrl"
                                       :label="getFieldLabel('selectedAnimal')"
                                       label-key="full_name"
                                       :initial-filters="selectedAnimalsInitialFilters"
                                       :placeholder="'Номер бирки/чипа или рег. номер'" />
                </div>
            </b-form-row>
        </div>

        <div v-show="!existing">
            <b-form-row class="mb-2">
                <form-field class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 required"
                             :label="getFieldLabel('shelterRegNumber')"
                             :editable="getAbility('shelterRegNumber')"
                             :value="object.shelterRegNumber"
                             :feedback="liveFeedback('shelterRegNumber')">
                    <template #field>
                        <b-form-input
                            id="shelterRegNumber"
                            class="w-100"
                            type="text"
                            v-model="$v.form.shelterRegNumber.$model"
                            :state="validateState('shelterRegNumber')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 required"
                             :label="getFieldLabel('breed')"
                             :editable="getAbility('breed')"
                             :value="object.breed"
                             :feedback="liveFeedback('breed')">
                    <template #field>
                            <single-select name="breed"
                               class="flex-grow-1"
                               v-model="form['breedObject']"
                               :url="getBreedsUrl"
                               label-key="full_name"
                               :has-search="false"
                               :label="getFieldLabel('breed')"
                               :state="getValidationClass('breed')"
                               v-on:select-changed="onModelObjectSingleSelectChanged"
                               v-on:select-cleared="onModelObjectSingleSelectCleared" />
                    </template>
                </form-field>
            </b-form-row>
            <b-form-row class="mb-2">
                <form-field class="col-xs-12 col-sm-6 col-lg-4 col-xl-3"
                             :label="getFieldLabel('labelId')"
                             :editable="getAbility('labelId')"
                             :value="object.labelId"
                             :feedback="liveFeedback('labelId')">
                    <template #field>
                        <b-form-input
                            id="labelId"
                            class="w-100"
                            type="text"
                            v-model="$v.form.labelId.$model"
                            :state="validateState('labelId')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field class="col-xs-12 col-sm-6 col-lg-4 col-xl-3"
                             :label="getFieldLabel('chipId')"
                             :editable="getAbility('chipId')"
                             :value="object.chipId"
                             :feedback="liveFeedback('chipId')">
                    <template #field>
                        <b-form-input
                            id="chipId"
                            class="w-100"
                            type="text"
                            v-model="$v.form.chipId.$model"
                            :state="validateState('chipId')">
                        </b-form-input>
                    </template>
                </form-field>

            </b-form-row>
        </div>

    </div>
</template>

<script>
    import { ObjectComponentMixin } from "@/components/Forms/ObjectComponentMixin";
    import {Animal} from "../../Animals/animal";
    import api from "../../../../api";
    import FormField from "../../../../components/Forms/FormField";
    import RadioList from "@/components/Select/RadioList";
    import SingleSelect from "@/components/Select/SingleSelect";
    import httpClient from "@/http";

    export default {
        name: "CatchingAnimal",
        components: {SingleSelect, RadioList, FormField },
        mixins: [ObjectComponentMixin],
        props: {
            remainingCount: { default: 0 },
            animalData : null,
            editable: { type: Boolean, default: true },
            collapsed: true
        },
        data() {
            return {
                existing: 1,
                existingChoices: [ { text: 'В системе', value: 1 }, { text: 'Новое', value: 0 } ],
                selectedAnimal: {},
                initialBreed: null,
            }
        },
        computed: {
            getSelectedAnimalId() {
                return this.existing ? this.selectedAnimal : this.object.id
            },
            getAnimalsUrl() {
                return api.animals.default.list();
            },
            getBreedsUrl() {
                return api.breeds.default.list();
            },
            // getGendersUrl() {
            //     return api.animals.genders.list();
            // },
            selectedAnimalsInitialFilters() {
                return [{key: 'is_alive', value: true}, {key: 'free', value: true}, {key: 'short', value: true}]
            }
        },
        methods: {
            fetchNextRegNumber() {
                httpClient.get(api.animals.nextRegNumber.list())
                    .then((response) => {
                        this.form.regNumber = response.data['number']
                        this.form.shelterRegNumber = this.form.regNumber
                    })
            }
        },
        beforeMount() {
            this.objectClass = Animal;
            this.objectData = this.animalData;
            this.apiEntryPoint = api.animals;
        },
        mounted() {
            this.onMount();
            this.resetForm().then(() => {
                if (!this.object.id) {
                    this.fetchNextRegNumber()
                }
            });
        },
    }
</script>

<style scoped>

</style>